<template>
   <div class="row">
       <div class="col col-12">
       </div>
   </div>
</template>

<script>
export default {
    name: 'VNFRProductPreview',
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            test: ''
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            return true
        }
    }
}
</script>
